/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindBusinessPartnerRepositoryCompanyPrefillQueryResponse,
  FindBusinessPartnerRepositoryCompanyPrefillPathParams,
  FindBusinessPartnerRepositoryCompanyPrefill404,
} from "../types/FindBusinessPartnerRepositoryCompanyPrefill.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findBusinessPartnerRepositoryCompanyPrefillQueryKey = (
  repositoryRecordId: FindBusinessPartnerRepositoryCompanyPrefillPathParams["repositoryRecordId"]
) =>
  [
    {
      url: "/v1/contacts/bp-autocomplete/company/:repositoryRecordId/prefill",
      params: { repositoryRecordId: repositoryRecordId },
    },
  ] as const

export type FindBusinessPartnerRepositoryCompanyPrefillQueryKey = ReturnType<
  typeof findBusinessPartnerRepositoryCompanyPrefillQueryKey
>

/**
 * @summary Get prefill payload from repository record
 * {@link /v1/contacts/bp-autocomplete/company/:repositoryRecordId/prefill}
 */
export async function findBusinessPartnerRepositoryCompanyPrefill(
  repositoryRecordId: FindBusinessPartnerRepositoryCompanyPrefillPathParams["repositoryRecordId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindBusinessPartnerRepositoryCompanyPrefillQueryResponse,
    ResponseErrorConfig<FindBusinessPartnerRepositoryCompanyPrefill404>,
    unknown
  >({
    method: "GET",
    url: `/v1/contacts/bp-autocomplete/company/${repositoryRecordId}/prefill`,
    ...requestConfig,
  })
  return res
}

export function findBusinessPartnerRepositoryCompanyPrefillQueryOptions(
  repositoryRecordId: FindBusinessPartnerRepositoryCompanyPrefillPathParams["repositoryRecordId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey =
    findBusinessPartnerRepositoryCompanyPrefillQueryKey(repositoryRecordId)
  return queryOptions<
    ResponseConfig<FindBusinessPartnerRepositoryCompanyPrefillQueryResponse>,
    ResponseErrorConfig<FindBusinessPartnerRepositoryCompanyPrefill404>,
    ResponseConfig<FindBusinessPartnerRepositoryCompanyPrefillQueryResponse>,
    typeof queryKey
  >({
    enabled: !!repositoryRecordId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findBusinessPartnerRepositoryCompanyPrefill(repositoryRecordId, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get prefill payload from repository record
 * {@link /v1/contacts/bp-autocomplete/company/:repositoryRecordId/prefill}
 */
export function useFindBusinessPartnerRepositoryCompanyPrefill<
  TData =
    ResponseConfig<FindBusinessPartnerRepositoryCompanyPrefillQueryResponse>,
  TQueryData =
    ResponseConfig<FindBusinessPartnerRepositoryCompanyPrefillQueryResponse>,
  TQueryKey extends QueryKey =
    FindBusinessPartnerRepositoryCompanyPrefillQueryKey,
>(
  repositoryRecordId: FindBusinessPartnerRepositoryCompanyPrefillPathParams["repositoryRecordId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindBusinessPartnerRepositoryCompanyPrefillQueryResponse>,
        ResponseErrorConfig<FindBusinessPartnerRepositoryCompanyPrefill404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findBusinessPartnerRepositoryCompanyPrefillQueryKey(repositoryRecordId)

  const query = useQuery(
    {
      ...findBusinessPartnerRepositoryCompanyPrefillQueryOptions(
        repositoryRecordId,
        config
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<FindBusinessPartnerRepositoryCompanyPrefill404>
  > & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}
